import i18n from 'modules/core/lib/i18n'

import { safeParseGroupBy } from 'modules/performance_analytics/components/helpers'

import { useGroupBy } from './GroupByProvider'
import Dropdown, { type DropdownOption } from './_Dropdown'

export type GroupByOption = DropdownOption<string>

type GroupByDropdownProps = {
  options: readonly GroupByOption[]
  defaultOpen?: boolean
  fullWidth?: boolean
  showClearOption?: boolean
}

function GroupByDropdown({
  options,
  defaultOpen = false,
  fullWidth = false,
  showClearOption = true,
}: GroupByDropdownProps) {
  const { groupBy, setGroupBy } = useGroupBy()

  const handleValueChange = (value?: string) => {
    if (value === undefined) {
      setGroupBy(undefined)
    } else {
      const parsedValue = safeParseGroupBy(value)
      setGroupBy(parsedValue)
    }
  }

  const dropdownValue = groupBy || undefined

  return (
    <Dropdown
      label={i18n.t('common.group_by')}
      options={options}
      value={dropdownValue}
      onValueChange={handleValueChange}
      defaultOpen={defaultOpen}
      fullWidth={fullWidth}
      showClearOption={showClearOption}
      clearText={i18n.t('common.clear_grouping')}
      maxWidth="300px"
      placeholder={i18n.t('common.select_grouping')}
    />
  )
}

export default GroupByDropdown
